export default class CreatePublicHolidayRequest {
    regionId: string = '';
    name: string = '';
    holidayDate: Date = new Date();
}